export default __webpack_public_path__ + "static/media/section2-pic2.667426ec.png";